var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
/* eslint-disable sonarjs/cognitive-complexity */
import { useQuery } from '@apollo/client';
import { useScrollIntoView } from '@bfa/nextjs-common/hooks';
import { clientLogging, cookieService } from '@bfa/nextjs-common/services';
import isEmpty from 'lodash/isEmpty';
import { useEffect, useState } from 'react';
import { GET_ON_THE_LIST_KEY, REFRESHMENT_REFERRAL_STEP_TWO, } from '../../../../constants';
import useBusinessConfiguration from '../../../../hooks/useBusinessConfiguration';
import useCreateSubscription from '../../../../hooks/useCreateSubscription';
import { NBTenant } from '../../../../types/enums';
import { ACQUISITION_LANDING_PAGE_EVENTS as EVENTS } from '../../../../utils/analytics/events';
import { setShowOnboardingTourCookie } from '../../../../utils/cookies';
import CookieName from '../../../../utils/cookies/cookieName';
import GET_ACQUISITION_LANDING from './GET_ACQUISITION_LANDING';
import GET_EXPERIMENT from './GET_EXPERIMENT';
var SHOW_CREATE_SUBSCRIPTION_BUTTON = 'VARIANT_A';
var SHOW_LEARN_MORE_AND_CREATE_SUBSCRIPTION_BUTTON = 'VARIANT_B';
var useAcquisitionLanding = function (userId, currentStarterKit) {
    var _a;
    var _b = useBusinessConfiguration(), tenant = _b.tenant, program = _b.program, trackEvent = _b.trackEvent;
    var _c = __read(useCreateSubscription(true), 2), createRefreshmentsSubscription = _c[0], createSubscriptionLoading = _c[1].loading;
    var _d = __read(useState(undefined), 2), shouldShowCheckIcon = _d[0], setShouldShowCheckIcon = _d[1];
    var _e = __read(useState(false), 2), shouldShowNotification = _e[0], setShowNotification = _e[1];
    var _f = __read(useState(''), 2), message = _f[0], setMessage = _f[1];
    var _g = __read(useState(false), 2), shouldShowError = _g[0], setShowError = _g[1];
    var _h = __read(useScrollIntoView(), 2), scrollRefTop = _h[0], onScrollTop = _h[1];
    var _j = __read(useScrollIntoView(), 2), scrollRefLearnMore = _j[0], onScrollLearnMore = _j[1];
    // Define CMS Content Names
    var currentStarterKitCarouselContentName = "".concat(tenant).concat(currentStarterKit);
    var notEligibleCarouselContentName = "".concat(tenant, "RefreshmentsAcquisitionNotEligibleCarouselSection");
    var defaultCarouselContentName = "".concat(tenant, "RefreshmentsAcquisitionCarouselSection");
    var _k = useQuery(GET_ACQUISITION_LANDING, {
        errorPolicy: 'ignore',
        variables: {
            program: program,
            currentStarterKitCarouselContentName: currentStarterKitCarouselContentName,
            notEligibleCarouselContentName: notEligibleCarouselContentName,
            defaultCarouselContentName: defaultCarouselContentName,
        },
    }), data = _k.data, loading = _k.loading, error = _k.error;
    // Execute this Onboarding Tour experiment query if the tenant is IPSY only
    var _l = useQuery(GET_EXPERIMENT, {
        errorPolicy: 'ignore',
        skip: tenant !== NBTenant.IPSY,
    }), experimentData = _l.data, experimentLoading = _l.loading, experimentError = _l.error;
    var layout = data === null || data === void 0 ? void 0 : data.me.layout;
    var isUserAbleToSubscribe = !!((_a = data === null || data === void 0 ? void 0 : data.me.subscriptionProgram) === null || _a === void 0 ? void 0 : _a.userCanSubscribe);
    // Onboarding Tour experiment conditions
    var shouldShowCreateSubscriptionButton = isUserAbleToSubscribe &&
        ((experimentData === null || experimentData === void 0 ? void 0 : experimentData.me.carouselVariant) === SHOW_CREATE_SUBSCRIPTION_BUTTON ||
            (experimentData === null || experimentData === void 0 ? void 0 : experimentData.me.carouselVariant) ===
                SHOW_LEARN_MORE_AND_CREATE_SUBSCRIPTION_BUTTON);
    var shouldShowLearnMoreLink = (experimentData === null || experimentData === void 0 ? void 0 : experimentData.me.carouselVariant) ===
        SHOW_LEARN_MORE_AND_CREATE_SUBSCRIPTION_BUTTON;
    var trackViewedMultipleCTA = shouldShowCreateSubscriptionButton || shouldShowLearnMoreLink;
    // Use current Starter Kit carousel if exists or default unless user is not able to subscribe.
    var carouselContent = isUserAbleToSubscribe
        ? (layout === null || layout === void 0 ? void 0 : layout.currentStarterKitCarouselContent) || (layout === null || layout === void 0 ? void 0 : layout.defaultCarouselContent)
        : layout === null || layout === void 0 ? void 0 : layout.notEligibleCarouselContent;
    /**
     * Function to add users to WaitList.
     */
    var addUserToWaitList = function () {
        localStorage.setItem("".concat(userId, "-").concat(GET_ON_THE_LIST_KEY), 'true');
        setShouldShowCheckIcon(true);
    };
    /**
     * Function to set Facebook Cookie if it comes from FB Share page.
     */
    var shouldFireSignUpWithFBShareEvent = function () {
        var isFBShareFinished = cookieService.getCookie(null, CookieName.REFRESHMENT_SHARING_STEP_COOKIE) === REFRESHMENT_REFERRAL_STEP_TWO;
        if (isFBShareFinished) {
            trackEvent(EVENTS.CLICK_ON_CREATE_SUBSCRIPTION_WITH_FB_SHARE);
        }
    };
    /**
     * Handler for click event of Add to Wait List button.
     *
     * @param scroll - Indicate if screen should scroll to top of the page or not.
     */
    var handleAddToWaitListButtonClick = function (scroll) {
        if (scroll === void 0) { scroll = false; }
        addUserToWaitList();
        if (scroll)
            onScrollTop({ behavior: 'smooth' });
    };
    /**
     * Handler for click event for Learn More button.
     */
    var handleLearnMoreLinkClick = function () {
        onScrollLearnMore({
            behavior: 'smooth',
            block: 'start',
        });
    };
    /**
     * Handler for click event of Create a new Subscription button.
     */
    var handleCreateSubscriptionButtonClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, subscriptionData, errors, e_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, createRefreshmentsSubscription()];
                case 1:
                    _a = _b.sent(), subscriptionData = _a.data, errors = _a.errors;
                    if (errors)
                        throw new Error(errors.toString());
                    if (!isEmpty(subscriptionData)) {
                        shouldFireSignUpWithFBShareEvent();
                        setShowError(false);
                        setShowNotification(true);
                        setMessage('Pop bottles! You have successfully signed-up for a Refreshments membership.');
                        setShowOnboardingTourCookie(true);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _b.sent();
                    clientLogging.logError(e_1);
                    setShowError(true);
                    setShowNotification(true);
                    setMessage("Sorry, we've sold out! Come back 1st thing next month or check your email for when you can claim your offer.");
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    /**
     * Prevent users from clicking again on Get On The List button if they already did it.
     */
    var checkIfUserOnWhitelist = function () {
        var storedValue = localStorage.getItem("".concat(userId, "-").concat(GET_ON_THE_LIST_KEY));
        setShouldShowCheckIcon(storedValue === 'true');
    };
    /**
     * Log analytics event for landing on Acquisition version of the Landing Page.
     */
    var logLandingEvent = function () {
        trackEvent(isUserAbleToSubscribe
            ? EVENTS.LAND_ON_PAGE_ALLOWED_USERS
            : EVENTS.LAND_ON_PAGE_NOT_ALLOWED_USERS);
        if (isUserAbleToSubscribe && trackViewedMultipleCTA) {
            trackEvent(EVENTS.LAND_ON_MULTIPLE_CTA);
        }
    };
    // We need this code to run only once and only on client side
    useEffect(function () {
        if (!loading &&
            !(error === null || error === void 0 ? void 0 : error.networkError) &&
            !experimentLoading &&
            !(experimentError === null || experimentError === void 0 ? void 0 : experimentError.networkError)) {
            checkIfUserOnWhitelist();
            logLandingEvent();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [error, loading, experimentError, experimentLoading]);
    return {
        error: error,
        loading: loading,
        experimentError: experimentError,
        experimentLoading: experimentLoading,
        createSubscriptionLoading: createSubscriptionLoading,
        shouldShowCheckIcon: shouldShowCheckIcon,
        shouldShowCreateSubscriptionButton: shouldShowCreateSubscriptionButton,
        shouldShowLearnMoreLink: shouldShowLearnMoreLink,
        shouldShowNotification: shouldShowNotification,
        shouldShowError: shouldShowError,
        message: message,
        handleLearnMoreLinkClick: handleLearnMoreLinkClick,
        handleAddToWaitListButtonClick: handleAddToWaitListButtonClick,
        handleCreateSubscriptionButtonClick: handleCreateSubscriptionButtonClick,
        scrollRefTop: scrollRefTop,
        scrollRefLearnMore: scrollRefLearnMore,
        content: {
            howItWorksContent: layout === null || layout === void 0 ? void 0 : layout.howItWorksContent,
            promotedProductContent: layout === null || layout === void 0 ? void 0 : layout.promotedProductContent,
            carouselContent: carouselContent,
        },
        isUserAbleToSubscribe: isUserAbleToSubscribe,
    };
};
export default useAcquisitionLanding;
